import { RATE_OPTIONS } from "./speech";

const PREFS_KEY = "bible-speech-prefs";
const CONTINUE_KEY = "bible-speech-continue";
const CONTINUE_TTL_MS = 15000;
const LISTEN_MODES = ["parallel", "zh", "en"];

const defaults = {
  rate: 1,
  voiceURI: { zh: "", en: "" },
  listenMode: "parallel",
  autoAdvance: true,
  collapsed: false,
};

const canUseStorage = (storage) => {
  try {
    return typeof window !== "undefined" && Boolean(window[storage]);
  } catch (error) {
    return false;
  }
};

const readJSON = (storage, key) => {
  if (!canUseStorage(storage)) return null;
  try {
    const raw = window[storage].getItem(key);
    return raw ? JSON.parse(raw) : null;
  } catch (error) {
    return null;
  }
};

const writeJSON = (storage, key, value) => {
  if (!canUseStorage(storage)) return;
  try {
    window[storage].setItem(key, JSON.stringify(value));
  } catch (error) {
    // quota / private mode
  }
};

const normalizePrefs = (value = {}) => {
  const rate = RATE_OPTIONS.includes(value.rate) ? value.rate : defaults.rate;
  const listenMode = LISTEN_MODES.includes(value.listenMode)
    ? value.listenMode
    : defaults.listenMode;
  return {
    rate,
    listenMode,
    autoAdvance: value.autoAdvance !== false,
    collapsed: Boolean(value.collapsed),
    voiceURI: {
      zh: value.voiceURI?.zh || "",
      en: value.voiceURI?.en || "",
    },
  };
};

export const loadSpeechPrefs = () =>
  normalizePrefs(readJSON("localStorage", PREFS_KEY) || {});

export const saveSpeechPrefs = (partial = {}) => {
  const next = normalizePrefs({ ...loadSpeechPrefs(), ...partial });
  writeJSON("localStorage", PREFS_KEY, next);
  return next;
};

export const markContinueListen = (chapterId) => {
  if (!chapterId) return;
  writeJSON("sessionStorage", CONTINUE_KEY, {
    id: String(chapterId),
    t: Date.now(),
  });
};

export const consumeContinueListen = (chapterId) => {
  const payload = readJSON("sessionStorage", CONTINUE_KEY);
  if (canUseStorage("sessionStorage")) {
    try {
      window.sessionStorage.removeItem(CONTINUE_KEY);
    } catch (error) {
      // ignore
    }
  }
  if (!payload || !chapterId) return false;
  if (String(payload.id) !== String(chapterId)) return false;
  if (!Number.isFinite(payload.t) || Date.now() - payload.t > CONTINUE_TTL_MS) {
    return false;
  }
  return true;
};
